module.exports = __webpack_public_path__ + "img/deltoides.ec1154c4.png";